// Use $ instead of $ without replacing global $
(function ($) {

  // apply padding to section
  if ($('.banner-with-info').length) {
    $(window).on('load resize', function () {
      var offsetLeft = $('header nav .container').offset().left + 20 + 'px';
      $('.banner-with-info .col-two .content-outer').css({
        'padding-left': offsetLeft
      })
    });
  }

  function setBannerHeight() {
    var winWidth = $(window).width();

    if(winWidth > 767) {
      var height = $('.banner-with-info.tradeshow .col-outer .col-two .v-middle-inner').height();
      $('.banner-with-info.tradeshow .col-outer .col-two').css({'height': height + 'px'});
    } else {
      $('.banner-with-info.tradeshow .col-outer .col-two').removeAttr('style');
    }
  }

  $(document).ready(function () {
    setBannerHeight();
  });

  $(window).on('resize', function () {
    setBannerHeight();
  });

  $(window).on('load', function () {
    $('body .banner-with-info .col-two .content-outer').css({"opacity": 1});
    // $('.banner-with-info.parts .col-two').matchHeight();

    // Set Super script tag

    if ($('.banner-with-info').length) {
      'use strict';
      $('body :not(script,sup,iframe)').contents().filter(function () {
        return this.nodeType === 3;
      }).replaceWith(function () {
        return this.nodeValue.replace(/[®]/g, '<sup>$&</sup>');
      });

      $('body :not(script,sup,iframe)').contents().filter(function () {
        return this.nodeType === 3;
      }).replaceWith(function () {
        return this.nodeValue.replace(/[©]/g, '<sup>$&</sup>');
      });

      $('body :not(script,sup,iframe)').contents().filter(function () {
        return this.nodeType === 3;
      }).replaceWith(function () {
        return this.nodeValue.replace(/[™]/g, '<sup>$&</sup>');
      });

      $('sup').each(function (index, el) {
        var thisParent = $(el).parent().html();
        var thisSup = thisParent.substr(0, thisParent.indexOf('<sup>')).slice(-1);
        $(el).addClass('sup-reg');
        if (thisSup === '.') {
          $(el).addClass('sup-reg-kern');
        }
      });
    }

    $(document).on('click', '.banner-with-info.parts .col-two .email-btn a', function (e) {
      e.preventDefault();
      $('#email-overlay').addClass('overlay-active');
      $('body').addClass('email-overlay-active');
    });

    $(document).on('click', '.banner-with-info.contact .col-two .email-btn a', function (e) {
      e.preventDefault();
      $('#email-overlay').addClass('overlay-active');
      $('body').addClass('email-overlay-active');
    });

  });

  // $(window).on('load resize', function () {
  //     var winWidth = $(window).width();
  //     if (winWidth < 768) {
  //         $('body.page-node-1 .intro-block').removeClass('p-0');
  //     } else {
  //         $('body.page-node-1 .intro-block').addClass('p-0');
  //     }
  // });

  // $(window).on('load', function () {
  //     var winWidth = $(window).width();
  //     if (winWidth < 768) {
  //         $('body.page-node-1 .intro-block').removeClass('p-0');
  //     } else {
  //         $('body.page-node-1 .intro-block').addClass('p-0');
  //     }
  // });

})(jQuery);